import { render, staticRenderFns } from "./ConfirmationDialogVT.vue?vue&type=template&id=1a4a0420"
import script from "./ConfirmationDialogVT.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogVT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports